import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import FauxSelect from '../Common/FauxSelect';
import LoadMore from '../Common/LoadMore';

const Roster = observer(class Roster extends React.Component {
  constructor() {
    super();
    this.handleFilter = this.handleFilter.bind(this);
    this.selectOption = this.selectOption.bind(this);
    this.handleAction = this.handleAction.bind(this);
    this.getCourseRoster = this.getCourseRoster.bind(this);
  }

  componentWillMount() {
    this.state = {
      query: '?limit=25&roles=learner',
      enrollmentSid: null,
      enrollmentName: null,
      fundingRuleSid: null,
      location: null,
      action: null,
      userSid: null
    };

    this.getCourseRoster(this.state.query);
    this.props.store.SessionStore.getCourseData(this.props.courseSid);
  }

  getCourseRoster() {
    this.props.store.EnrollmentStore.getCourseRoster(this.state.query, null, this.props.courseSid);
  }

  handleFilter() {
    let query = ''

    if(this.filter.value || this.status.value) {
      query = '?limit=25';
    }

    if(this.filter.value) {
      query += `&roles=${JSON.parse(this.filter.value).role}`;
    }

    if(this.status.value) {
      query += `&state=${this.status.value}`;
    }

    this.setState({
      query
    }, function(){
      this.getCourseRoster();
    });
  }

  selectOption(e, props) {
    const action = e.target.getAttribute('data-action');
    this.handleAction(e, action, props.enrollmentSid, props.userSid, props.studentName);
  }

  handleAction(e, action, enrollmentSid, userSid, studentName) {
    const drawerContent = action;
    const { SessionStore, SettingsStore, StudentStore } = this.props.store;

    this.setState({
      enrollmentSid,
      userSid
    });

    // Open a new tab logged in as the student
    if(drawerContent === 'Impersonate') {
      let studentWindow = null;

      if(SessionStore.userData.role.toLowerCase() === 'instructor') {
        studentWindow = window.open('', '_blank');
      }

      StudentStore.impersonate(enrollmentSid, SettingsStore.integration.accessKey, studentWindow, userSid);
    }
  }

  renderResults() {
    const { EnrollmentStore, SessionStore } = this.props.store;
    const { translation } = this.props;

    // Roster actions
    const actions = []

    const impersonateAction = {
      title: translation.actions.impersonate.label,
      action: 'Impersonate',
      helper: translation.actions.impersonate.helper
    }

    actions.push(impersonateAction);

    if(EnrollmentStore.courseRoster.length > 0) {
      return(
        <table>
          <thead>
            <tr>
              <th id="heading-name" className="subtitle" scope="col">{translation.student}</th>
              <th id="heading-role" className="subtitle" scope="col">{translation.role}</th>
              <th id="heading-email" className="subtitle" scope="col">{translation.email}</th>
              <th id="heading-actions" className="subtitle table-action" scope="col">{translation.action}</th>
            </tr>
          </thead>
          <tbody>
            {EnrollmentStore.courseRoster.map(
              (key, i) =>
              <tr key={i}>
                <td aria-labelledby="heading-name">{key.lastName}, {key.firstName}</td>
                <td aria-labelledby="heading-role" className="capitalize">{key.role}</td>
                <td aria-labelledby="heading-email"><a href={`mailto:${key.email}`}>{key.email}</a></td>
                <td aria-labelledby="heading-actions" className="actions">
                  {key.role.toLowerCase() === 'learner' &&
                    <div>
                      <FauxSelect
                        default={translation.action_select}
                        options={actions}
                        onClick={this.selectOption}
                        studentName={`${key.firstName} ${key.lastName}`}
                        enrollmentSid={key.enrollmentSid}
                        userSid={key.userSid}
                        parent={this}
                        skipText={true}
                      />
                    </div>
                  }
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )
    } else if(!SessionStore.loading && EnrollmentStore.courseRoster.length === 0) {
      let role = '';

      if(this.filter.value) {
        role = JSON.parse(this.filter.value).title;
      }

      return (
        <span className="no-results">
          {this.status.value &&
            translation.no_results_status.replace('%status%', this.status.value).replace('%role%', role)
          }

          {!this.status.value &&
            translation.no_results.replace('%role%', role)
          }
        </span>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;
    const { EnrollmentStore, SessionStore } = this.props.store;

    if(SessionStore.courseData) {
      const { synchronization } = SessionStore.courseData;

      return(
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.page_title}</h1>
            </div>
          </header>

          <div className="wrap">
            {/* Note if roster sync is not enabled */}
            {
              ((
                synchronization &&
                synchronization.enrollment &&
                !synchronization.enrollment.lastRun &&
                !synchronization.enrollment.nextRun
              ) || (
                synchronization && !synchronization.enrollment
              ) || !synchronization) &&

              <p className="note note--alt note--prominent"><strong>Note:</strong>{translation.sync_not_active}</p>
            }

            {/* Show sync stats if they exist */}
            {
              synchronization &&
              synchronization.enrollment &&
              synchronization.enrollment.lastRun &&
              synchronization.enrollment.nextRun &&

              <div className="box box--right">
                <p>
                  <span className="title">
                    {moment.utc(synchronization.enrollment.lastRun).local().tz(moment.tz.guess()).format('M/D/YYYY [at] h:mma z')}
                  </span>

                  <span className="title">
                    {moment.utc(synchronization.enrollment.nextRun).local().tz(moment.tz.guess()).format('M/D/YYYY [at] h:mma z')}
                  </span>
                </p>
              </div>
            }

            {this.renderResults()}

            <LoadMore
              url={EnrollmentStore.rosterNext}
              group={EnrollmentStore.courseRoster}
              text="Load more enrollments"
              store={EnrollmentStore}
              {...this.props}
            />
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('Roster')(Roster);



// WEBPACK FOOTER //
// ./src/app/components/Roster/Enrollments.js